import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#FAF7F0] bg-sage rounded-xl hover:bg-[#8FA896] transition-colors duration-300 shadow-sm hover:shadow-md';
  if (href) {
    return <motion.a href={href} onClick={props.onClick as React.MouseEventHandler<HTMLAnchorElement> | undefined} className={`${baseStyles} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-31">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseStyles} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-32">
      {children}
    </motion.button>;
}